import createSagaMiddleware from "redux-saga";
import { all, fork } from "typed-redux-saga";
import { appSaga } from "./app/operations";
import { applyMiddleware, combineReducers } from "@reduxjs/toolkit";
import { AppReducer } from "./app";
import { BlogReducer, blogSaga } from "./blog";
import { homeSaga } from "./home/operations";
import { HomeReducer } from "./home/reducers";
import { ContactReducer, contactSaga } from "./contact";
import { searchSaga } from "./search/operations";
import { SearchReducer } from "./search/reducers";
import { PropertyReducer, propertySaga } from "./property";

const sagaMiddleware = createSagaMiddleware();

export function runSaga() {
    sagaMiddleware.run(function* () {
        yield all ([
            fork(appSaga),
            fork(homeSaga),
            fork(blogSaga),
            fork(contactSaga),
            fork(searchSaga),
            fork(propertySaga)
        ])
    })
}

export const middlewares = applyMiddleware(sagaMiddleware);

export const reducers = combineReducers({
    app: AppReducer,
    home: HomeReducer,
    blog: BlogReducer,
    contact: ContactReducer,
    search: SearchReducer,
    property: PropertyReducer
})